import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { ArrayHelper } from "@workspace/common";
import { toast } from "react-toastify";
import * as MultiSelectUtil from "./multiSelectUtil";

function RecruiterFilter({
  onChange,
  value,
  isFilterCleared,
  setIsFilterCleared,
  width = "auto",
  allowMenuOverflow = false,
}) {
  const userData = useSelector((state) => state?.UserGroupReducer?.users);
  const [recruiterOptions, setRecruiterOptions] = useState([]);
  const [selectedRecruiters, setSelectedRecruiters] = useState([]);

  const getUserBasedOnUserGroup = (userData, userGroupList) => {
    if (userData) {
      return userData.filter((user) => {
        const userGroups = user?.userGroup;
        const userGroupNames = userGroups?.map(
          (userGroup) => userGroup?.groupName
        );
        return userGroupNames.some((userGroupName) =>
          userGroupList.includes(userGroupName)
        );
      });
    }
  };

  useEffect(() => {
    if (Array.isArray(userData)) {
      const recruiterUserData = getUserBasedOnUserGroup(userData, [
        "Recruiter Group",
      ]);
      const recruiterOptionsMapped = userData?.map((recruiter) => ({
        value: `${recruiter.firstName} ${recruiter.lastName}`,
        label: `${recruiter.firstName} ${recruiter.lastName} (${recruiter.email})`,
      }));
      setRecruiterOptions(
        MultiSelectUtil.replaceSpecialCharactersData(recruiterOptionsMapped)
      );
    } else {
      setRecruiterOptions([]);
    }
  }, [userData]);

  ArrayHelper.sortArrayObjIcase(recruiterOptions, "label");

  useEffect(() => {
    if (value && recruiterOptions) {
      try {
        const selectedRecruiterNames = JSON.parse(value);
        const selectedRecruiterOptions = selectedRecruiterNames?.map((name) => {
          return recruiterOptions?.find((option) => option.data === name);
        });
        setSelectedRecruiters(selectedRecruiterOptions);
      } catch (e) {
        toast.error(
          "Invalid JSON format. Please delete and recreate the custom view"
        );
        return;
      }
    }
    if (!value) {
      setSelectedRecruiters([]);
    }
  }, [value, recruiterOptions]);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#8AAED6" : "lightgray",
      "&:hover": {
        borderColor: state.isFocused ? "#0a56ae" : "lightgray",
      },
      backgroundColor: state.isDisabled ? "#EFF2F7" : "base.backgroundColor",
      width: width,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "black !important" : provided.color,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  };

  useEffect(() => {
    if (isFilterCleared) {
      setSelectedRecruiters([]);
      setIsFilterCleared(false);
    }
  }, [isFilterCleared]);

  const handleChange = (recruiters) => {
    setSelectedRecruiters(recruiters);
    const toStringRecruiters = (recruiters) => {
      return recruiters.map((recruiter) => recruiter.data);
    };
    if (recruiters.length === 0) {
      onChange("");
      return;
    }
    onChange(JSON.stringify(toStringRecruiters(recruiters)));
  };

  return (
    <div>
      <Select
        isMulti
        value={selectedRecruiters}
        options={recruiterOptions}
        onChange={handleChange}
        placeholder="Select Recruiter"
        className="basic-multi-select"
        classNamePrefix={"select"}
        {...(allowMenuOverflow && { menuPortalTarget: document.body })}
        styles={
          allowMenuOverflow
            ? customStyles
            : { ...customStyles, menuPortal: undefined }
        }
      />
    </div>
  );
}

export default RecruiterFilter;
